import React from "react";
interface props {
  className?: string;
}

function GoogleSvg({ className }: props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="16"
      className={className}
      fill="none"
      viewBox="0 0 17 16"
    >
      <path
        fill="#4285F4"
        fillRule="evenodd"
        d="M16.18 8.183c0-.567-.05-1.112-.145-1.636H8.5V9.64h4.306a3.68 3.68 0 01-1.597 2.415v2.007h2.585c1.513-1.393 2.386-3.443 2.386-5.88z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#34A853"
        fillRule="evenodd"
        d="M8.5 16c2.16 0 3.972-.717 5.295-1.939l-2.585-2.007c-.717.48-1.633.764-2.71.764-2.083 0-3.847-1.408-4.476-3.298H1.352v2.072A7.997 7.997 0 008.5 16z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FBBC05"
        fillRule="evenodd"
        d="M4.024 9.52c-.16-.48-.251-.992-.251-1.52 0-.526.09-1.04.25-1.52V4.409H1.352A7.997 7.997 0 00.5 8.001c0 1.29.31 2.513.85 3.593L4.025 9.52z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#EA4335"
        fillRule="evenodd"
        d="M8.5 3.182c1.175 0 2.23.403 3.059 1.196l2.294-2.294C12.468.793 10.657 0 8.501 0a7.997 7.997 0 00-7.15 4.407L4.025 6.48c.63-1.89 2.393-3.298 4.477-3.298z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default GoogleSvg;
